import styled from 'styled-components';

import { crFont11 } from '../../../app/global-styles';

import { Icon } from '@controlrooms/components';
import { ICONS } from '@controlrooms/constants';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 0; /* Allow flex shrinking */
  cursor: pointer;
  overflow: visible; /* Allow tooltip to be visible */
  &:hover .primary-label {
    color: ${({ theme }) => theme.v2.timeDisplay.primaryTextHover};
    * {
      color: ${({ theme }) => theme.v2.timeDisplay.primaryTextHover};
    }
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  min-width: 0; /* Allow flex shrinking */
  flex: 1; /* Take available space */
  position: relative; /* Create positioning context for tooltip */

  svg {
    margin-top: 4px;
    flex-shrink: 0; /* Prevent icon from shrinking */
  }
`;

export const TimeRangeContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

export const DurationContainer = styled.div`
  font-weight: 300;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  font-family: 'Open Sans', sans-serif;
  color: ${({ theme }) => theme.v2.timeDisplay.secondaryTextColor};
`;

export const TimeCard = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0;
  gap: 10px;
  overflow: visible; /* Allow tooltip to be visible */
  min-width: 0; /* Allow flex shrinking */
  flex: 1; /* Take available space */
`;

export const Label = styled.div`
  font-style: normal;
  font-weight: 400;
`;

export const PrimaryLabel = styled(Label)`
  ${crFont11}
  margin-right: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; /* Allow flex shrinking */
  flex: 1; /* Take available space but allow shrinking */
  display: block; /* Ensure ellipsis works properly */
  color: ${({ theme }) => theme.v2.timeDisplay.primaryTextColor};

  .date {
    font-weight: 300;
    color: ${({ theme }) => theme.v2.timeDisplay.secondaryTextColor};
  }
`;

export const SubLabel = styled(Label)`
  font-size: 11px;
  color: ${({ theme }) => theme.v2.timeDisplay.secondaryTextColor};

  .time {
    color: ${({ theme }) => theme.v2.timeDisplay.primaryTextColor};
  }
`;

export const TimeZone = styled(SubLabel)`
  font-weight: 400;
  font-size: 11px;
  font-family: 'Open Sans', sans-serif;
`;

export const Separator = styled.div`
  font-size: 20px;
  margin: 0 10px;
  font-weight: 600;
  line-height: 24px;
`;

export const Chevron = styled(Icon).attrs((props) => ({
  color: props.theme.v2.timeDisplay.chevronColor,
  name: ICONS.Chevron,
}))``;

export const TooltipWrapper = styled.div`
  /* Preserve ellipsis behavior while enabling tooltip */
  display: flex;
  min-width: 0; /* Allow flex shrinking */
  flex: 1; /* Take available space but allow shrinking */

  /* Ensure tooltip has high z-index and proper positioning */
  & > span {
    display: flex;
    min-width: 0; /* Allow flex shrinking */
    flex: 1; /* Take available space but allow shrinking */
  }
`;

export const TimeSelectContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.modal.containerBorderColor};
  width: 100%;
  height: 100%;

  .date-time-range-input {
    margin-top: 8px;
  }
`;
